import { render, staticRenderFns } from "./UsernameRecoveryOptions.vue?vue&type=template&id=85baed5c&scoped=true&"
import script from "./UsernameRecoveryOptions.vue?vue&type=script&lang=js&"
export * from "./UsernameRecoveryOptions.vue?vue&type=script&lang=js&"
import style0 from "./UsernameRecoveryOptions.vue?vue&type=style&index=0&id=85baed5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85baed5c",
  null
  
)

export default component.exports